import { DateTimeStr, PntStationStatusItemDtoV2, PntStationStatusMatchDtoV2 } from '@mi-front/core';
import { uniqueScheduleField } from '../spot/schedule-status-spot-utils';

/** Advertiser from the date-schedule, falling back to unique values on slot schedules. */
export function getMentionsAdvertiser(item: PntStationStatusItemDtoV2): string {
  return (
    item.dateSchedule?.advertiser?.trim() || uniqueScheduleField(item.schedules ?? [], 'advertiser')
  );
}

/** Mention title from the date-schedule. */
export function getMentionsName(item: PntStationStatusItemDtoV2): string {
  return item.dateSchedule?.name?.trim() ?? '';
}

/** Extra detections exist when total matches exceed those linked to a schedule. */
export function hasPossibleUnmatchedMentionsMatches(item: PntStationStatusItemDtoV2): boolean {
  return item.status.matchesCount > item.status.matchesWithScheduleCount;
}

/**
 * Detections that did not confirm against any slot schedule.
 * Linked matches are identified by datetime on `mentionMatch`.
 */
export function getUnmatchedMentionsMatches(
  item: PntStationStatusItemDtoV2,
): PntStationStatusMatchDtoV2[] {
  const linkedDatetimes = new Set(
    (item.schedules ?? [])
      .map((schedule) => schedule.mentionMatch?.datetime)
      .filter((datetime): datetime is DateTimeStr => datetime != null),
  );

  return (item.matches ?? []).filter((match) => !linkedDatetimes.has(match.datetime));
}
